import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconCircleCheckSvg } from './IconCircleCheckSvg';

export const IconCircleCheck: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconCircleCheckSvg} {...iconProps} />;
};
